"use client";
import { IconCouponTag } from "@repo/assets/images";
import { CurrencySymbol } from "@repo/components";
import cx from "classnames";
import { useTranslations } from "next-intl";

const CartCalculations = ({ summary, couponName }) => {
  const t = useTranslations("Common");

  const items = [
    {
      label: t("Subtotal"),
      value: (
        <CurrencySymbol
          variant="smallSpecial"
          value={summary?.formattedSubTotal}
        />
      ),
      id: 0,
    },
    {
      label: t("Delivery_Cost"),
      value:
        summary?.shippingCharges === 0 ? (
          t("Free")
        ) : (
          <CurrencySymbol
            variant="smallSpecial"
            value={summary?.shippingCharges}
          />
        ),
      id: 2,
    },
  ];
  if (summary?.couponDiscount !== 0 && summary?.couponDiscount !== undefined) {
    items.push({
      label: t("Coupon"),
      value: (
        <CurrencySymbol
          variant="smallSpecial"
          value={summary?.couponDiscount}
        />
      ),
      isDiscount: true,
      id: 3,
      couponName: couponName,
    });
  }
  if (summary?.tax !== 0 && summary?.tax !== undefined) {
    items.push({
      label: t("Tax"),
      value: (
        <CurrencySymbol
          variant="smallSpecial"
          value={summary?.formattedTax || summary?.tax}
        />
      ),
      id: 1,
    });
  }
  return (
    <ul className="px-3 tracking-wide">
      {items?.map((item, index) => (
        <li key={index} className="flex pb-2">
          <div
            className={cx({
              "flex items-center": item.couponName,
            })}
          >
            {item.label}
            {item.couponName && (
              <span className="text-miniCart-promocode-couponSuccessText flex items-center font-medium">
                <IconCouponTag className="mx-1" />
                {item.couponName}
              </span>
            )}
          </div>
          <div
            className={cx("ms-auto font-semibold", {
              "text-miniCart-promocode-couponSuccessText": item.isDiscount,
            })}
          >
            {item.value}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default CartCalculations;
